(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, kids) {
    var n = tag.indexOf('svg:') === 0 ? document.createElementNS(NS, tag.slice(4)) : document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function fmt(v, d) { return v.toLocaleString('en-US', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
  function signed(v, d) { return (v >= 0 ? '+' : '−') + fmt(Math.abs(v), d); }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  // Runs fn(k) with k easing 0 → 1 over ms; returns a cancel function.
  function animate(ms, fn) {
    if (reduceMotion) { fn(1); return function () {}; }
    var t0 = null, id = 0;
    function step(now) {
      if (t0 === null) t0 = now;
      var k = Math.min(1, (now - t0) / ms);
      fn(ease(k));
      if (k < 1) id = requestAnimationFrame(step);
    }
    id = requestAnimationFrame(step);
    return function () { cancelAnimationFrame(id); };
  }
  // Linear blend of two same-shaped values (numbers, arrays, plain objects); nulls snap to the target.
  function lerp(a, b, k) {
    if (typeof b === 'number') return typeof a === 'number' ? a + (b - a) * k : b;
    if (Array.isArray(b)) return b.map(function (v, i) { return lerp(a && a[i], v, k); });
    if (b && typeof b === 'object') {
      var o = {};
      for (var key in b) o[key] = lerp(a && a[key], b[key], k);
      return o;
    }
    return b;
  }
  function zeroed(b) {
    if (typeof b === 'number') return 0;
    if (Array.isArray(b)) return b.map(zeroed);
    if (b && typeof b === 'object') {
      var o = {};
      for (var key in b) o[key] = zeroed(b[key]);
      return o;
    }
    return b;
  }
  var STATS_MS = 160;
  var uid = 0;

  // Linear interpolation of a run at an RPM; null outside the run's range.
  function at(pts, rpm) {
    if (rpm < pts[0][0] || rpm > pts[pts.length - 1][0]) return null;
    for (var i = 1; i < pts.length; i++) {
      if (rpm <= pts[i][0]) {
        var a = pts[i - 1], b = pts[i], t = (rpm - a[0]) / ((b[0] - a[0]) || 1);
        return [rpm, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
      }
    }
    return pts[pts.length - 1];
  }
  function peak(pts, col) {
    return pts.reduce(function (best, p) { return p[col] > best[col] ? p : best; }, pts[0]);
  }
  // Gains as defined in the M-Engineering calibration notes:
  // "Max" = largest difference at the same RPM, "Peak" = difference between each plot's highest reading.
  function stats(run, stock) {
    var out = {};
    [['hp', 1], ['tq', 2]].forEach(function (c) {
      var col = c[1], maxD = null, maxP = null;
      run.forEach(function (p) {
        var s = at(stock, p[0]);
        if (!s) return;
        var d = p[col] - s[col], pc = d / s[col];
        if (!maxD || d > maxD.v) maxD = { v: d, rpm: p[0] };
        if (!maxP || pc > maxP.v) maxP = { v: pc, rpm: p[0] };
      });
      var pr = peak(run, col), ps = peak(stock, col);
      out[c[0]] = {
        maxInc: maxD, maxPct: maxP,
        peakInc: pr[col] - ps[col], peakPct: (pr[col] - ps[col]) / ps[col],
        peakRun: pr, peakStock: ps
      };
    });
    return out;
  }

  // ---- Dynojet CSV import (same rules as scripts/dyno_csv_to_json.py)
  // Fuels are open-ended: any fuel named in a file gets its own button. These just add nicer captions.
  var FUEL_CAPTIONS = {
    'ACN91': 'ACN91 (Arizona, California, Nevada 91)'
  };
  var RON = { '91': 95, '93': 98, '100': 103 };   // US pump octane (R+M)/2 → RON, as on M-Engineering's notes
  function fuelCaption(f) {
    if (FUEL_CAPTIONS[f]) return FUEL_CAPTIONS[f];
    if (/^\d+$/.test(f)) return f + ' Octane (R+M)/2' + (RON[f] ? ' or ' + RON[f] + ' RON' : '');
    var e = f.match(/^E(\d+)$/);
    if (e) return f + ' - ' + e[1] + '% Ethanol';
    return f;
  }
  // Button order: ACN91, pump octanes low → high, ethanol blends low → high, then anything else A–Z.
  function fuelRank(f) {
    if (f === 'ACN91') return [0, 0, ''];
    if (/^\d+$/.test(f)) return [1, +f, ''];
    var e = f.match(/^E(\d+)$/);
    if (e) return [2, +e[1], ''];
    return [3, 0, f];
  }
  function fuelCompare(a, b) {
    var x = fuelRank(a), y = fuelRank(b);
    return x[0] - y[0] || x[1] - y[1] || (x[2] < y[2] ? -1 : x[2] > y[2] ? 1 : 0);
  }
  function chartSubtitle(run) {
    return 'Stock vs Stage ' + run.stage + ' / ' + (run.caption || fuelCaption(run.fuel));
  }
  var KNOWN_FUELS = ['ACN91', '91', '93', '100', 'E85'];

  // Columns used: PwrT (HP at the wheels), dTrq (lb-ft at the wheels), dRPM (engine RPM), found by header name.
  function parseDynojet(text) {
    var rows = text.split(/\r?\n/).map(function (l) { return l.split(',').map(function (c) { return c.trim(); }); });
    var head = rows.filter(function (r) { return /^0heading/i.test(r[0] || ''); })[0];
    if (!head) throw new Error("it doesn't look like a dyno export");
    var hp = head.indexOf('PwrT'), tq = head.indexOf('dTrq'), rpm = head.indexOf('dRPM');
    if (hp < 0 || tq < 0 || rpm < 0) throw new Error("it's missing the horsepower, torque or RPM column");
    var pts = [];
    rows.forEach(function (r) {
      if (/^0/.test(r[0] || '') || r.length <= Math.max(hp, tq, rpm)) return;
      var p = [Math.round(parseFloat(r[rpm])), Math.round(parseFloat(r[hp]) * 10) / 10, Math.round(parseFloat(r[tq]) * 10) / 10];
      // Dynojet pads the export with an empty sample (rpm 0) at the end.
      if (isNaN(p[0]) || isNaN(p[1]) || isNaN(p[2]) || p[0] < 500 || p[1] <= 0) return;
      pts.push(p);
    });
    if (pts.length < 10) throw new Error('it only has ' + pts.length + ' rows of data');
    return pts.sort(function (a, b) { return a[0] - b[0]; });
  }

  // Reads stage + fuel from a file name, forgivingly: "Stage1_93.csv", "Stage 2 - 100 oct.csv",
  // "stg2+_E85.csv", "ANC91 Stage 1.csv", "Stage1_E50.csv", "Stage2_Race Gas.csv", "stock_baseline.csv".
  // Shopify's duplicate-upload suffix (_3f2a9c1e-7b4d-…) is ignored. Returns null when the name can't be read.
  var FILLER = /^(oct|octane|fuel|map|slot\d*|run\d*|pull\d*|dyno|final|new|copy|v\d+|vs|stock|baseline|and)$/;
  function readFuel(rest) {
    var m;
    if ((m = rest.match(/(?:^|[^a-z0-9])(?:acn|anc)[ _-]?91(?![0-9])/))) return 'ACN91';
    if ((m = rest.match(/(?:^|[^a-z0-9])e[ _-]?(\d{2,3})(?![0-9])/))) return 'E' + m[1];
    if ((m = rest.match(/(?:^|[^0-9])(8[5-9]|9\d|1[01]\d)(?![0-9])/))) return m[1];
    // Anything else ("race gas", "c16", "meth") becomes its own fuel, written as named.
    var words = rest.split(/[^a-z0-9+]+/).filter(function (w) { return w && !FILLER.test(w); });
    return words.length ? words.join(' ').toUpperCase() : null;
  }
  function classify(name) {
    var n = name.toLowerCase()
      .replace(/\.csv$/, '')
      .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '')
      .replace(/plus/g, '+');
    // "Stage2+" is its own stage (Stage 2 plus injectors), not a Stage 2 duplicate.
    var st = n.match(/(?:^|[^a-z])(?:stage|stg|s)[ _-]*(\d)(\+?)(?![0-9])/);
    if (st) {
      var fuel = readFuel(n.slice(0, st.index) + ' ' + n.slice(st.index + st[0].length));
      return fuel ? { stage: st[1] + st[2], fuel: fuel } : null;
    }
    return /stock|base[ _-]?line/.test(n) ? { stock: true } : null;
  }

  function loadFiles(files, car, defaultFuel, report) {
    // Ignore anything that isn't named like a dyno pull (a stray PDF or notes file shouldn't break the chart).
    var wanted = files.filter(function (f) {
      var ok = /\.csv$/i.test(f.name) && classify(f.name);
      if (!ok) report.skipped.push(f.name);
      return ok;
    });
    return Promise.all(wanted.map(function (f) {
      return fetch(f.url).then(function (r) {
        if (!r.ok) throw new Error("the file couldn't be downloaded (error " + r.status + ')');
        return r.text();
      }).then(function (text) { return { name: f.name, pts: parseDynojet(text) }; })
        .catch(function (e) { throw new Error(f.name + ': ' + e.message); });
    })).then(function (parsed) {
      var D = { car: car, defaultFuel: defaultFuel || '93', stock: null, runs: [] };
      // Files are in admin list order; a later upload for the same stage + fuel replaces the earlier one.
      var byKey = {};
      parsed.forEach(function (p) {
        var c = classify(p.name);
        if (c.stock) {
          if (D.stock) report.replaced.push(report.stockName);
          D.stock = p.pts; report.stockName = p.name;
          return;
        }
        var k = c.stage + '|' + c.fuel;
        if (byKey[k]) report.replaced.push(byKey[k].p.name);
        byKey[k] = { c: c, p: p };
      });
      Object.keys(byKey).forEach(function (k) {
        var c = byKey[k].c, p = byKey[k].p;
        D.runs.push({
          stage: c.stage, fuel: c.fuel, fuelLabel: c.fuel, caption: fuelCaption(c.fuel),
          label: 'Stage ' + c.stage + ' · ' + c.fuel, shortLabel: 'Stage ' + c.stage, pts: p.pts
        });
      });
      if (!D.stock) throw new Error('there is no stock run (name it stock_baseline.csv)');
      if (!D.runs.length) throw new Error('there are no tuned runs (name them like Stage1_93.csv)');
      D.runs.sort(function (a, b) {
        return stageRank(a.stage) - stageRank(b.stage) || fuelCompare(a.fuel, b.fuel);
      });
      return D;
    });
  }

  // Gains need stock readings inside each run's RPM range; drop runs that don't overlap at all.
  function usable(D, report) {
    D.runs = D.runs.filter(function (r) {
      var keep = r.pts.some(function (p) { return at(D.stock, p[0]); });
      if (!keep && report) report.dropped.push(r.label);
      return keep;
    });
    if (!D.runs.length) throw new Error("none of the tuned runs cover the same RPM range as the stock run");
    return D;
  }

  function exportPayload(D) {
    return {
      car: D.car,
      defaultFuel: D.defaultFuel,
      stock: D.stock,
      runs: D.runs.map(function (r) {
        return {
          stage: r.stage,
          fuel: r.fuel,
          fuelLabel: r.fuelLabel || r.fuel,
          caption: r.caption,
          pts: r.pts
        };
      })
    };
  }
  function jsonForScript(obj) {
    return JSON.stringify(obj).replace(/</g, '\\u003c');
  }
  function attrEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }
  function exportFileName(car) {
    var slug = String(car || 'chart').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return 'm-engineering-dyno-' + (slug || 'chart') + '.html';
  }
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return Promise.reject(new Error('clipboard'));
  }
  function buildStandaloneHtml(opts) {
    var payload = opts.payload;
    var car = opts.car || (payload && payload.car) || 'Dyno chart';
    var defaultFuel = opts.defaultFuel || (payload && payload.defaultFuel) || '93';
    var logo = opts.logo || '';
    var css = (opts.fragment ? '' : 'html,body{margin:0;background:#000;}') +
      '.mdyno{--mdyno-body:"Nunito Sans","Helvetica Neue",Arial,sans-serif;}\n' +
      (opts.css || '') +
      '\n.dyno-chart-section{background:transparent !important;padding:24px 16px;}' +
      '.mdyno-notes,.mdyno-notes summary,.mdyno-notes ul{color:#8e9091 !important;}' +
      '.mdyno-tip,.mdyno-tip th,.mdyno-tip td,.mdyno-tip .mdyno-tip-rpm{color:#fff !important;}' +
      '.mdyno-tip thead th{color:#8e9091 !important;}' +
      '.mdyno-tip .mdyno-gain td:nth-child(2){color:#e0313f !important;}' +
      '.mdyno-tip .mdyno-gain td:nth-child(3){color:#4d9bfa !important;}';
    var js = String(opts.js || '').replace(/<\/script/gi, '<\\/script');
    var logoAttr = logo ? ' data-mdyno-logo="' + attrEsc(logo) + '"' : '';
    var inner = '<div class="dyno-chart-section">\n' +
      '<div class="mdyno" data-mdyno data-mdyno-car="' + attrEsc(car) + '"' +
      ' data-mdyno-default-fuel="' + attrEsc(defaultFuel) + '"' + logoAttr + '>\n' +
      '<script type="application/json" data-mdyno-data>' + jsonForScript(payload) + '</script>\n' +
      '</div>\n</div>\n' +
      '<script>\n' + js + '\n</script>\n';
    if (opts.fragment) return '<style>\n' + css + '\n</style>\n' + inner;
    return '<!DOCTYPE html>\n<html lang="en">\n<head>\n<meta charset="utf-8">\n' +
      '<meta name="viewport" content="width=device-width, initial-scale=1">\n' +
      '<title>' + attrEsc(car) + ' \u2014 M-Engineering dyno</title>\n' +
      '<style>\n' + css + '\n</style>\n</head>\n<body>\n' + inner + '</body>\n</html>\n';
  }
  function fetchText(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error("couldn't read " + url + ' (' + r.status + ')');
      return r.text();
    });
  }
  function logoDataUrl(url) {
    if (!url) return Promise.resolve('');
    if (/^data:/i.test(url)) return Promise.resolve(url);
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('logo');
      return r.blob();
    }).then(function (blob) {
      return new Promise(function (resolve, reject) {
        var fr = new FileReader();
        fr.onload = function () { resolve(fr.result); };
        fr.onerror = reject;
        fr.readAsDataURL(blob);
      });
    }).catch(function () { return url; });
  }
  function standaloneHtml(root, D, fragment) {
    var cssLink = document.querySelector('link[href*="section-dyno-chart"]');
    var jsScript = document.querySelector('script[src*="dyno-chart"]');
    if (!cssLink || !jsScript) return Promise.reject(new Error('missing chart assets'));
    return Promise.all([
      fetchText(cssLink.href),
      fetchText(jsScript.src),
      logoDataUrl(root.getAttribute('data-mdyno-logo') || '')
    ]).then(function (parts) {
      return buildStandaloneHtml({
        css: parts[0],
        js: parts[1],
        payload: exportPayload(D),
        logo: parts[2],
        car: D.car,
        defaultFuel: D.defaultFuel || root.getAttribute('data-mdyno-default-fuel'),
        fragment: fragment
      });
    });
  }
  function downloadStandalone(root, D) {
    standaloneHtml(root, D, false).then(function (html) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([html], { type: 'text/html;charset=utf-8' }));
      a.download = exportFileName(D.car);
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
    }).catch(function (e) {
      if (window.console) console.error('[dyno-chart] export', e);
      window.alert('Could not build the HTML file. Try again on this product page.');
    });
  }
  function copyStandalone(root, D, btn) {
    var prev = btn && btn.textContent;
    if (btn) btn.textContent = 'Copying…';
    standaloneHtml(root, D, true).then(function (html) {
      return copyText(html).then(function () {
        if (!btn) return;
        btn.textContent = 'Copied';
        setTimeout(function () { btn.textContent = prev; }, 1600);
      });
    }).catch(function (e) {
      if (btn && prev) btn.textContent = prev;
      if (window.console) console.error('[dyno-chart] export', e);
      window.alert('Could not copy the HTML. Try Download HTML, or copy again on this product page.');
    });
  }

  // Staff see a file report in the theme editor, or on any page with ?dyno-check in the URL.
  function checking(root) {
    return root.hasAttribute('data-mdyno-design-mode') || /[?&]dyno-check\b/.test(location.search);
  }

  function showReport(root, report, D, error) {
    if (!checking(root)) return;
    var lines = [];
    if (D) {
      var byStage = {};
      D.runs.forEach(function (r) { (byStage[r.stage] = byStage[r.stage] || []).push(r.fuel); });
      lines.push('Showing: stock' + Object.keys(byStage).map(function (s) { return ', Stage ' + s + ' (' + byStage[s].join(', ') + ')'; }).join(''));
    }
    var fresh = D ? D.runs.map(function (r) { return r.fuel; })
      .filter(function (f, i, a) { return a.indexOf(f) === i && KNOWN_FUELS.indexOf(f) < 0; }) : [];
    if (fresh.length) lines.push('New fuel names. Each gets its own button, so check the spelling: ' + fresh.join(', '));
    if (report.skipped.length) lines.push("Not used, because the file name doesn't say the stage and fuel: " + report.skipped.join(', '));
    if (report.replaced.length) lines.push('Not used, because a newer file covers the same run: ' + report.replaced.join(', '));
    if (report.dropped.length) lines.push("Not used, because it doesn't cover the same RPM range as the stock run: " + report.dropped.join(', '));
    if (error) lines.push('The chart is not showing because ' + error.message + '. Customers see nothing here until this is fixed.');
    var kids = [
      el('strong', { text: "Dyno chart check (customers don't see this box)" })
    ].concat(lines.map(function (l) { return el('p', { text: l }); }));
    if (D) {
      kids.push(el('div', { class: 'mdyno-export-row' }, [
        el('button', {
          type: 'button',
          class: 'mdyno-export',
          text: 'Download HTML',
          onclick: function () { downloadStandalone(root, D); }
        }),
        el('button', {
          type: 'button',
          class: 'mdyno-export',
          text: 'Copy HTML to clipboard',
          onclick: function () { copyStandalone(root, D, this); }
        })
      ]));
      kids.push(el('p', { text: 'Download a file for partner sites, or copy HTML and paste it into Confluence’s HTML plugin (scripts must be allowed).' }));
    }
    var box = el('div', { class: 'mdyno-report' + (error ? ' mdyno-report--error' : '') }, kids);
    root.insertBefore(box, root.firstChild);
  }

  function start(root) {
    var car = root.getAttribute('data-mdyno-car');
    var json = root.querySelector('[data-mdyno-data]');
    var files = root.querySelector('[data-mdyno-files]');
    var report = { skipped: [], replaced: [], dropped: [], stockName: null };
    function ok(D) {
      D = usable(D, report);
      init(root, D);
      showReport(root, report, D, null);
    }
    function bad(e) { fail(root, e, report); }
    if (json) {
      try {
        var D = JSON.parse(json.textContent);
        if (car) D.car = car;
        ok(D);
      } catch (e) { bad(e); }
      return;
    }
    if (!files) return;
    loadFiles(JSON.parse(files.textContent), car, root.getAttribute('data-mdyno-default-fuel'), report)
      .then(ok)
      .catch(bad);
  }

  function fail(root, e, report) {
    if (window.console) console.error('[dyno-chart]', e);
    // Show nothing rather than guess: the old image slides stay hidden (they may be another car's plots).
    root.textContent = '';
    if (checking(root)) showReport(root, report || { skipped: [], replaced: [], dropped: [] }, null, e);
    else (root.closest('.shopify-section') || root.closest('.dyno-chart') || root).hidden = true;
  }

  // Stage 0 < 1 < 2 < 2+ < 3. JSON data may carry stages as numbers, so compare as strings.
  function stageRank(s) { s = String(s); return parseFloat(s) + (s.slice(-1) === '+' ? 0.5 : 0); }

  function init(root, D) {
    D.runs.forEach(function (r) {
      r.stage = String(r.stage);
      if (!r.caption && r.fuel) r.caption = fuelCaption(r.fuel);
      r.shortLabel = 'Stage ' + r.stage;
    });
    var stages = D.runs.map(function (r) { return r.stage; })
      .filter(function (v, i, a) { return a.indexOf(v) === i; })
      .sort(function (a, b) { return stageRank(a) - stageRank(b); });
    var state = { stage: stages[stages.length - 1], fuel: null, show: { hp: true, tq: true, shp: true, stq: true }, rpm: null };
    var defaultFuel = D.defaultFuel;

    function runsFor(stage) { return D.runs.filter(function (r) { return r.stage === stage; }); }
    function current() {
      var list = runsFor(state.stage);
      return list.filter(function (r) { return r.fuel === state.fuel; })[0] || list[0];
    }

    // ---- DOM skeleton
    var stageSeg = el('div', { class: 'mdyno-seg', role: 'group', 'aria-label': 'Stage' });
    var fuelSeg = el('div', { class: 'mdyno-seg', role: 'group', 'aria-label': 'Fuel' });
    var controls = el('div', { class: 'mdyno-controls' }, [
      el('div', { class: 'mdyno-group' }, [el('span', { class: 'mdyno-group-label', text: 'Stage' }), stageSeg]),
      el('div', { class: 'mdyno-group' }, [el('span', { class: 'mdyno-group-label', text: 'Fuel' }), fuelSeg])
    ]);
    var chartTitle = el('h2', { class: 'mdyno-chart-title', text: D.car });
    var chartSub = el('p', { class: 'mdyno-chart-sub' });
    var svg = el('svg:svg', { class: 'mdyno-plot', tabindex: '0', role: 'img' });
    var tip = el('div', { class: 'mdyno-tip', 'aria-hidden': 'true' });
    var logoHref = root.getAttribute('data-mdyno-logo');
    var mark = logoHref
      ? el('img', { class: 'mdyno-mark', src: logoHref, alt: '', 'aria-hidden': 'true' })
      : null;
    var plotwrap = el('div', { class: 'mdyno-plotwrap' }, [svg, mark]);
    var slider = el('input', { type: 'range', class: 'mdyno-slider', step: '10', 'aria-label': 'Inspect RPM' });
    var sliderOut = el('output', { class: 'mdyno-slider-val' });
    var sliderRow = el('label', { class: 'mdyno-slider-row' }, [el('span', { class: 'mdyno-slider-label', text: 'Inspect RPM' }), slider, sliderOut]);
    var legend = el('div', { class: 'mdyno-legend' });
    var fillHpId = 'mdyno-fill-hp-' + (++uid);
    var fillTqId = 'mdyno-fill-tq-' + uid;
    var statsBox = el('div', { class: 'mdyno-stats' });
    var notes = el('details', { class: 'mdyno-notes' }, [
      el('summary', { text: 'How these numbers are calculated' }),
      el('ul', {}, [
        el('li', { text: 'All figures are measured at the wheels (WHP and lb-ft). Every dyno reads a little differently, so the percentage gains are the best comparison between dynos.' }),
        el('li', { text: 'Max Increase is the largest difference between the tuned and stock curves at the same RPM.' }),
        el('li', { text: 'Peak Increase is the difference between the highest reading on each plot.' }),
        el('li', { text: 'Hover or drag on the chart, use the RPM slider, or the arrow keys to read values at any RPM.' })
      ])
    ]);
    var headCopyKids = [];
    if (!root.hasAttribute('data-mdyno-hide-heading')) headCopyKids.push(chartTitle);
    headCopyKids.push(chartSub, controls);
    var head = el('div', { class: 'mdyno-head' }, [
      el('div', { class: 'mdyno-head-copy' }, headCopyKids),
      tip
    ]);
    var chart = el('div', { class: 'mdyno-chart' }, [head, plotwrap, sliderRow, legend]);
    var statsCol = el('div', { class: 'mdyno-stats-col' }, [statsBox, notes]);
    root.appendChild(el('div', { class: 'mdyno-body' }, [chart, statsCol]));

    var SERIES = [
      { key: 'stq', col: 2, stock: true, color: 'var(--mdyno-tq)', dash: '7 5', label: function () { return 'Stock Torque'; } },
      { key: 'tq', col: 2, stock: false, color: 'var(--mdyno-tq)', dash: null, label: function (r) { return r.shortLabel + ' Torque'; } },
      { key: 'shp', col: 1, stock: true, color: 'var(--mdyno-hp)', dash: '7 5', label: function () { return 'Stock HP'; } },
      { key: 'hp', col: 1, stock: false, color: 'var(--mdyno-hp)', dash: null, label: function (r) { return r.shortLabel + ' HP'; } }
    ];

    function renderControls() {
      stageSeg.textContent = '';
      stages.forEach(function (s) {
        stageSeg.appendChild(el('button', {
          type: 'button', 'aria-pressed': String(s === state.stage), text: 'Stage ' + s,
          onclick: function () { state.stage = s; render(); }
        }));
      });
      var list = runsFor(state.stage);
      if (!list.some(function (r) { return r.fuel === state.fuel; })) {
        state.fuel = list.some(function (r) { return r.fuel === defaultFuel; }) ? defaultFuel : list[0].fuel;
      }
      fuelSeg.textContent = '';
      list.forEach(function (r) {
        fuelSeg.appendChild(el('button', {
          type: 'button', 'aria-pressed': String(r.fuel === state.fuel), text: r.fuelLabel,
          onclick: function () { state.fuel = r.fuel; render(); }
        }));
      });
    }

    function renderLegend(run) {
      legend.textContent = '';
      SERIES.forEach(function (s) {
        var sw = el('svg:svg', { width: '26', height: '8', 'aria-hidden': 'true' }, [
          el('svg:line', { x1: '1', y1: '4', x2: '25', y2: '4', stroke: s.color, 'stroke-width': s.stock ? '2.5' : '3.5', 'stroke-dasharray': s.dash ? '5 3' : '', 'stroke-linecap': 'round' })
        ]);
        legend.appendChild(el('button', {
          type: 'button', 'aria-pressed': String(state.show[s.key]),
          onclick: function () { state.show[s.key] = !state.show[s.key]; render(); }
        }, [sw, document.createTextNode(s.label(run))]));
      });
    }

    var shownStats = null, stopStats = function () {}, revealed = false;
    function statRows(run, st) {
      return [
        ['Max % TQ Gain', fmt(st.tq.maxPct.v * 100, 2) + '%', 'Max % WHP Gain', fmt(st.hp.maxPct.v * 100, 2) + '%'],
        ['Peak % TQ Gain', fmt(st.tq.peakPct * 100, 2) + '%', 'Peak % WHP Gain', fmt(st.hp.peakPct * 100, 2) + '%'],
        ['Peak TQ Increase', signed(st.tq.peakInc, 1) + ' lb-ft', 'Peak WHP Increase', signed(st.hp.peakInc, 1) + ' whp'],
        ['Max TQ Increase', [signed(st.tq.maxInc.v, 1) + ' lb-ft', '@ ' + fmt(Math.round(st.tq.maxInc.rpm / 10) * 10) + ' RPM'], 'Max WHP Increase', [signed(st.hp.maxInc.v, 1) + ' whp', '@ ' + fmt(Math.round(st.hp.maxInc.rpm / 10) * 10) + ' RPM']],
        ['Stock Peak TQ', fmt(st.tq.peakStock[2], 1) + ' lb-ft', 'Stock Peak WHP', fmt(st.hp.peakStock[1], 1) + ' whp'],
        [run.shortLabel + ' Peak TQ', fmt(st.tq.peakRun[2], 1) + ' lb-ft', run.shortLabel + ' Peak WHP', fmt(st.hp.peakRun[1], 1) + ' whp']
      ];
    }
    function renderStats(run) {
      var target = stats(run.pts, D.stock);
      if (!revealed && !reduceMotion) {
        shownStats = zeroed(target);
        paintStats(run, shownStats);
        return;
      }
      var from = shownStats || zeroed(target);
      stopStats();
      statsBox.classList.remove('is-updating');
      void statsBox.offsetWidth;
      statsBox.classList.add('is-updating');
      stopStats = animate(STATS_MS, function (k) {
        shownStats = lerp(from, target, k);
        paintStats(run, shownStats);
      });
    }
    function paintStats(run, st) {
      var rows = statRows(run, st);
      var dl = statsBox.querySelector('dl');
      if (!dl) {
        dl = el('dl');
        rows.forEach(function (r) {
          [['mdyno-stat mdyno-stat--tq', r[0], r[1]], ['mdyno-stat mdyno-stat--hp', r[2], r[3]]].forEach(function (pair) {
            var v = pair[2];
            var dd = Array.isArray(v)
              ? el('dd', {}, [el('span', { class: 'mdyno-stat-val', text: v[0] }), el('small', { text: v[1] })])
              : el('dd', {}, [el('span', { class: 'mdyno-stat-val', text: v })]);
            dl.appendChild(el('div', { class: pair[0] }, [el('dt', { text: pair[1] }), dd]));
          });
        });
        statsBox.appendChild(dl);
        return;
      }
      var items = dl.children;
      var i = 0;
      rows.forEach(function (r) {
        [[r[0], r[1]], [r[2], r[3]]].forEach(function (pair) {
          var box = items[i++];
          if (!box) return;
          box.querySelector('dt').textContent = pair[0];
          var v = pair[1];
          var val = box.querySelector('.mdyno-stat-val');
          var small = box.querySelector('small');
          if (Array.isArray(v)) {
            if (val) val.textContent = v[0];
            if (small) small.textContent = v[1];
          } else if (val) {
            val.textContent = v;
          }
        });
      });
    }

    // ---- chart geometry (redrawn at the real pixel width so text stays crisp and readable)
    var geo = null;
    // Every curve is drawn from the same RPM grid so a stage/fuel switch can morph point by point.
    var GRID = 180, rpmLo = Infinity, rpmHi = -Infinity;
    D.runs.concat([{ pts: D.stock }]).forEach(function (r) {
      rpmLo = Math.min(rpmLo, r.pts[0][0]);
      rpmHi = Math.max(rpmHi, r.pts[r.pts.length - 1][0]);
    });
    function gridRpm(i) { return rpmLo + (rpmHi - rpmLo) * i / (GRID - 1); }
    function sample(pts, col) {
      var out = [];
      for (var i = 0; i < GRID; i++) { var p = at(pts, gridRpm(i)); out.push(p ? p[col] : null); }
      return out;
    }
    function curvesFor(run) { return { hp: sample(run.pts, 1), tq: sample(run.pts, 2) }; }
    function linePath(vals) {
      var d = '', pen = false;
      vals.forEach(function (v, i) {
        if (v == null) { pen = false; return; }
        d += (pen ? 'L' : 'M') + geo.x(gridRpm(i)).toFixed(1) + ' ' + geo.y(v).toFixed(1);
        pen = true;
      });
      return d;
    }
    function areaPath(vals) {
      var first = -1, last = -1;
      vals.forEach(function (v, i) { if (v != null) { if (first < 0) first = i; last = i; } });
      if (first < 0) return '';
      var base = geo.y(0).toFixed(1);
      return linePath(vals) + 'L' + geo.x(gridRpm(last)).toFixed(1) + ' ' + base + 'L' + geo.x(gridRpm(first)).toFixed(1) + ' ' + base + 'Z';
    }
    var shownCurves = null, stopCurves = function () {}, introPlayed = false;
    function pathLen(p) {
      try { return p.getTotalLength(); } catch (e) { return 0; }
    }
    function armPath(p) {
      var len = pathLen(p);
      if (!len) return;
      p.style.strokeDasharray = String(len);
      p.style.strokeDashoffset = String(len);
    }
    function fadeIn(node, ms, wait) {
      if (!node) return;
      node.style.opacity = '0';
      node.style.transition = 'opacity ' + ms + 'ms ease ' + wait + 'ms';
      requestAnimationFrame(function () { node.style.opacity = '1'; });
    }
    function playChartIntro() {
      if (introPlayed) return;
      introPlayed = true;
      if (reduceMotion || !geo) return;
      var delay = 80;
      ['stq', 'tq', 'shp', 'hp'].forEach(function (key) {
        var p = geo.paths[key];
        if (!p) return;
        var len = pathLen(p);
        if (!len) return;
        p.style.transition = 'stroke-dashoffset 1.05s cubic-bezier(0.22, 1, 0.36, 1) ' + delay + 'ms';
        p.style.strokeDashoffset = '0';
        delay += 100;
        p.addEventListener('transitionend', function done(ev) {
          if (ev.propertyName !== 'stroke-dashoffset') return;
          p.removeEventListener('transitionend', done);
          p.style.transition = '';
          p.style.strokeDasharray = '';
          p.style.strokeDashoffset = '';
        });
      });
      fadeIn(geo.areaTq, 700, 280);
      fadeIn(geo.areaHp, 700, 380);
    }
    function reveal() {
      if (revealed) return;
      revealed = true;
      root.classList.add('is-in');
      playChartIntro();
      renderStats(current());
    }
    function paintCurves(c) {
      shownCurves = c;
      if (geo.paths.hp) geo.paths.hp.setAttribute('d', linePath(c.hp));
      if (geo.paths.tq) geo.paths.tq.setAttribute('d', linePath(c.tq));
      if (geo.areaHp) geo.areaHp.setAttribute('d', areaPath(c.hp));
      if (geo.areaTq) geo.areaTq.setAttribute('d', areaPath(c.tq));
    }
    function morphTo(run) {
      var from = shownCurves, target = curvesFor(run);
      stopCurves();
      stopCurves = animate(from ? 480 : 0, function (k) { paintCurves(from ? lerp(from, target, k) : target); });
    }
    function drawChart(run) {
      var W = Math.max(280, plotwrap.clientWidth || 640);
      // Phones get a near-square plot so the curves aren't squashed flat; wider screens keep a wide chart.
      var H = W < 560 ? Math.round(Math.max(300, W * 0.95)) : Math.round(Math.min(460, Math.max(260, W * 0.56)));
      var m = { l: W < 480 ? 48 : 64, r: W < 480 ? 48 : 64, t: 14, b: 50 };
      // Axis range covers every run so the chart doesn't shift when switching stage or fuel.
      var all = D.runs.reduce(function (acc, r) { return acc.concat(r.pts); }, D.stock.slice());
      var rMin = Math.floor(Math.min.apply(null, all.map(function (p) { return p[0]; })) / 250) * 250;
      var rMax = Math.ceil(Math.max.apply(null, all.map(function (p) { return p[0]; })) / 250) * 250;
      var vMax = Math.max.apply(null, D.runs.map(function (r) { return Math.max.apply(null, r.pts.map(function (p) { return Math.max(p[1], p[2]); })); }));
      var yMax = Math.ceil(vMax / 100) * 100, yStep = yMax > 600 ? 100 : 50;
      var x = function (r) { return m.l + (r - rMin) / (rMax - rMin) * (W - m.l - m.r); };
      var y = function (v) { return H - m.b - v / yMax * (H - m.t - m.b); };
      geo = { W: W, H: H, m: m, x: x, y: y, rMin: rMin, rMax: rMax };

      // Size comes from CSS (width: 100%) + viewBox; a fixed width attribute would hold the card open
      // at whatever width the first draw happened at.
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.setAttribute('aria-label', D.car + ' ' + run.label + ' versus stock, wheel horsepower and torque from ' + fmt(run.pts[0][0]) + ' to ' + fmt(run.pts[run.pts.length - 1][0]) + ' RPM');
      svg.textContent = '';

      var g = el('svg:g', { class: 'mdyno-grid' });
      var axisFont = W < 480 ? 13 : 15;
      for (var v = 0; v <= yMax; v += yStep) {
        g.appendChild(el('svg:line', { x1: m.l, x2: W - m.r, y1: y(v), y2: y(v), stroke: 'var(--mdyno-grid)', 'stroke-width': '1' }));
        g.appendChild(el('svg:text', { x: m.l - 8, y: y(v) + 4, 'text-anchor': 'end', fill: 'var(--mdyno-axis)', 'font-size': axisFont, text: v }));
        g.appendChild(el('svg:text', { x: W - m.r + 8, y: y(v) + 4, 'text-anchor': 'start', fill: 'var(--mdyno-axis)', 'font-size': axisFont, text: v }));
      }
      // RPM labels need ~4.5 characters of room each; widen the step until they can't touch.
      // Phones use short labels (3k); each label needs about that many characters of room.
      var shortX = W < 480, labelChars = shortX ? 2.8 : 4.6;
      var plotW = W - m.l - m.r, xStep = 500;
      while (plotW * xStep / (rMax - rMin) < axisFont * labelChars || (shortX && xStep < 1000)) xStep *= 2;
      for (var r = Math.ceil(rMin / xStep) * xStep; r <= rMax; r += xStep) {
        g.appendChild(el('svg:line', { x1: x(r), x2: x(r), y1: m.t, y2: H - m.b, stroke: 'var(--mdyno-grid)', 'stroke-width': '1' }));
        g.appendChild(el('svg:text', { x: x(r), y: H - m.b + 19, 'text-anchor': 'middle', fill: 'var(--mdyno-axis)', 'font-size': axisFont, text: shortX ? r / 1000 + 'k' : fmt(r) }));
      }
      g.appendChild(el('svg:text', { x: (m.l + W - m.r) / 2, y: H - 8, 'text-anchor': 'middle', fill: 'var(--mdyno-text)', 'font-size': W < 480 ? '12' : '14', 'font-weight': '700', 'letter-spacing': '1', text: 'ENGINE SPEED (RPM)' }));
      var midY = (m.t + H - m.b) / 2;
      g.appendChild(el('svg:text', { x: 14, y: midY, transform: 'rotate(-90 14 ' + midY + ')', 'text-anchor': 'middle', fill: 'var(--mdyno-text)', 'font-size': W < 480 ? '12' : '14', 'font-weight': '700', 'letter-spacing': '1', text: 'HORSEPOWER (WHP)' }));
      g.appendChild(el('svg:text', { x: W - 14, y: midY, transform: 'rotate(90 ' + (W - 14) + ' ' + midY + ')', 'text-anchor': 'middle', fill: 'var(--mdyno-text)', 'font-size': W < 480 ? '12' : '14', 'font-weight': '700', 'letter-spacing': '1', text: 'TORQUE (FT-LBS)' }));
      svg.appendChild(g);

      svg.appendChild(el('svg:defs', {}, [
        el('svg:linearGradient', { id: fillHpId, x1: '0', y1: '0', x2: '0', y2: '1' }, [
          el('svg:stop', { offset: '0', 'stop-color': 'var(--mdyno-hp)', 'stop-opacity': '.32' }),
          el('svg:stop', { offset: '1', 'stop-color': 'var(--mdyno-hp)', 'stop-opacity': '0' })
        ]),
        el('svg:linearGradient', { id: fillTqId, x1: '0', y1: '0', x2: '0', y2: '1' }, [
          el('svg:stop', { offset: '0', 'stop-color': 'var(--mdyno-tq)', 'stop-opacity': '.32' }),
          el('svg:stop', { offset: '1', 'stop-color': 'var(--mdyno-tq)', 'stop-opacity': '0' })
        ])
      ]));
      geo.areaHp = state.show.hp ? el('svg:path', { fill: 'url(#' + fillHpId + ')', stroke: 'none' }) : null;
      geo.areaTq = state.show.tq ? el('svg:path', { fill: 'url(#' + fillTqId + ')', stroke: 'none' }) : null;
      if (geo.areaTq) svg.appendChild(geo.areaTq);
      if (geo.areaHp) svg.appendChild(geo.areaHp);

      // Stock curves first so the tuned curves sit on top.
      geo.paths = {};
      SERIES.slice().sort(function (a, b) { return b.stock - a.stock; }).forEach(function (s) {
        if (!state.show[s.key]) return;
        var p = el('svg:path', {
          fill: 'none', stroke: s.color, 'stroke-width': s.stock ? '2.25' : '3.25',
          'stroke-dasharray': s.dash || '', 'stroke-linejoin': 'round', 'stroke-linecap': 'round', opacity: s.stock ? '.85' : '1'
        });
        if (s.stock) p.setAttribute('d', linePath(sample(D.stock, s.col)));
        geo.paths[s.key] = p;
        svg.appendChild(p);
      });
      paintCurves(shownCurves || curvesFor(run));
      if (!introPlayed && !reduceMotion) {
        SERIES.forEach(function (s) { if (geo.paths[s.key]) armPath(geo.paths[s.key]); });
        if (geo.areaTq) geo.areaTq.style.opacity = '0';
        if (geo.areaHp) geo.areaHp.style.opacity = '0';
      }

      geo.cross = el('svg:line', { class: 'mdyno-cross', y1: m.t, y2: H - m.b, stroke: 'rgba(255,255,255,.55)', 'stroke-width': '1' });
      svg.appendChild(geo.cross);
      geo.dots = {};
      SERIES.forEach(function (s) {
        geo.dots[s.key] = el('svg:circle', { class: 'mdyno-dot', r: s.stock ? '3.5' : '4.5', fill: s.stock ? '#000' : s.color, stroke: s.color, 'stroke-width': '2' });
        svg.appendChild(geo.dots[s.key]);
      });
      moveCross(run);
    }

    function setInspecting(on) {
      root.classList.toggle('is-inspecting', on);
      tip.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) tip.setAttribute('aria-live', 'polite');
      else tip.removeAttribute('aria-live');
    }

    function moveCross(run) {
      if (!geo) return;
      var inspecting = state.rpm != null;
      setInspecting(inspecting);
      var lo = run.pts[0][0], hi = run.pts[run.pts.length - 1][0];
      var rpm = Math.max(lo, Math.min(hi, inspecting ? state.rpm : defaultRpm(run)));
      var t = at(run.pts, rpm), s = at(D.stock, rpm);
      var cx = geo.x(rpm);
      // Slider steps and every RPM readout snap to 10 RPM so they always agree.
      slider.min = Math.ceil(lo / 10) * 10; slider.max = Math.floor(hi / 10) * 10; slider.value = Math.round(rpm / 10) * 10;
      sliderOut.textContent = fmt(Math.round(rpm / 10) * 10) + ' RPM';
      geo.cross.setAttribute('x1', cx);
      geo.cross.setAttribute('x2', cx);
      SERIES.forEach(function (ser) {
        var p = ser.stock ? s : t, dot = geo.dots[ser.key];
        var on = p && state.show[ser.key];
        dot.style.display = on ? '' : 'none';
        if (on) { dot.setAttribute('cx', cx); dot.setAttribute('cy', geo.y(p[ser.col])); }
      });

      var rowsHtml = '';
      function row(name, p, cls) {
        rowsHtml += '<tr' + (cls ? ' class="' + cls + '"' : '') + '><td>' + name + '</td><td>' + p[0] + '</td><td>' + p[1] + '</td></tr>';
      }
      row(run.shortLabel, [fmt(t[1], 1), fmt(t[2], 1)]);
      if (s) {
        row('Stock', [fmt(s[1], 1), fmt(s[2], 1)]);
        row('Gain', [signed(t[1] - s[1], 1), signed(t[2] - s[2], 1)], 'mdyno-gain');
      }
      // Fill the tip even while hidden so the header keeps its width; CSS hides it until inspect.
      tip.innerHTML = '<div class="mdyno-tip-rpm">' + fmt(Math.round(rpm / 10) * 10) + ' RPM</div><table class="mdyno-tip-table"><thead><tr><th></th><th>WHP</th><th>Lb-ft</th></tr></thead><tbody>' + rowsHtml + '</tbody></table>';
    }

    // Slider parks here until the first inspect; keyboard steps also start from this RPM.
    function defaultRpm(run) { return stats(run.pts, D.stock).hp.maxInc.rpm; }

    function rpmFromEvent(ev) {
      var rect = svg.getBoundingClientRect();
      var px = (ev.clientX - rect.left) / rect.width * geo.W;
      return geo.rMin + (px - geo.m.l) / (geo.W - geo.m.l - geo.m.r) * (geo.rMax - geo.rMin);
    }
    function inspectAt(rpm) {
      state.rpm = rpm;
      moveCross(current());
    }
    svg.addEventListener('pointermove', function (ev) { inspectAt(rpmFromEvent(ev)); });
    svg.addEventListener('pointerdown', function (ev) { inspectAt(rpmFromEvent(ev)); });
    function inspectSlider() { inspectAt(parseFloat(slider.value)); }
    slider.addEventListener('pointerdown', inspectSlider);
    slider.addEventListener('input', inspectSlider);
    svg.addEventListener('keydown', function (ev) {
      var run = current(), step = ev.shiftKey ? 500 : 100;
      var r = state.rpm == null ? defaultRpm(run) : state.rpm;
      if (ev.key === 'ArrowRight') r += step;
      else if (ev.key === 'ArrowLeft') r -= step;
      else return;
      ev.preventDefault();
      inspectAt(Math.max(run.pts[0][0], Math.min(run.pts[run.pts.length - 1][0], r)));
    });

    function render() {
      renderControls();
      var run = current();
      chartSub.textContent = chartSubtitle(run);
      renderLegend(run);
      renderStats(run);
      drawChart(run);
      morphTo(run);
    }

    render();
    (function setupReveal() {
      if (reduceMotion) { reveal(); return; }
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || 0;
      if (rect.top < vh * 0.92 && rect.bottom > 80) { reveal(); return; }
      if (!('IntersectionObserver' in window)) { reveal(); return; }
      var io = new IntersectionObserver(function (ents) {
        if (!ents.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        reveal();
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      io.observe(root);
    })();
    var lastW = plotwrap.clientWidth;
    // Redraw at the new width (phone rotation, window resize). The window listener backs up
    // ResizeObserver, which some embedded/background browsers don't deliver.
    function refit() {
      if (Math.abs(plotwrap.clientWidth - lastW) < 2) return;
      lastW = plotwrap.clientWidth;
      drawChart(current());
    }
    if (window.ResizeObserver) new ResizeObserver(refit).observe(plotwrap);
    window.addEventListener('resize', refit);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-mdyno]:not([data-mdyno-ready])');
    Array.prototype.forEach.call(roots, function (r) { r.setAttribute('data-mdyno-ready', ''); start(r); });
  }
  initAll();
  // Theme editor re-renders the section markup when settings change.
  document.addEventListener('shopify:section:load', initAll);
})();
